import Vue from 'vue'
// Lib imports
import axios from 'axios'
var production = true
Vue.prototype.$app_mode = "local"
Vue.prototype.$app_address = "http://*******.com/"
var SERVER = " http://localhost:7099"
if(production) {
  if(Vue.prototype.$app_mode == "production")
     SERVER = " http://serve.royal-crowne.com:9099"
  else if(Vue.prototype.$app_mode == "local")
        SERVER = " http://localhost:9099"
}
Vue.prototype.$http = axios.create({
  baseURL: SERVER + '/api/'
})

Vue.prototype.$fileserver = SERVER + '/public/' 